import clsx from "clsx";

const estiloEditarFrete = require("../../../../estilos/editarEntregaFreteCompartilhado.module.scss").default;
import { useFormik } from "formik";
import React from "react";
import { InputNumerico } from "../../../inputs/InputNumerico";
import { Frete } from "../AbaFrete";
import { classeParaLabelsFormularioComFundoEscuro } from "../../../../estilos/classeParaLabelsFormularioComFundoEscuro";
import globalMU from "../../../../../globalMU";
import { IOrcamento } from "../../../../types/IOrcamento";
import { useAppSelector } from "../../../../redux/hooks";
import store from "app/redux/store/store";
import { gravarTelasAlteradasNaoSalvaAction } from "app/redux/telaOrcamentoAlteradaNaoSalvaSlice";
const estilosFormulario = require('../../../../estilos/formulario.module.scss').default

export type EditarFreteProps = {
  somenteLeitura: boolean;
  frete: Frete;
  onAplicarFrete: (Frete: Frete) => void;
};

export const EditarFrete = (props: EditarFreteProps) => {
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
  const formik = useFormik({
    initialValues: { ...props.frete },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  return (
    <>
      <div className={clsx(estilosFormulario.formulario, classeParaLabelsFormularioComFundoEscuro)}
        id="EditarFrete_Formulario"
      >
        <label>Carga</label>
        <div style={{ fontWeight: 700, backgroundColor: "var(--mu-superficie, #FFFFFF)" }}
          id="EditarFrete_Carga"
        >
          {formik.values.Carga.toUpperCase()}
        </div>

        <label>Tipo Entrega </label>
        <div
          id="EditarFrete_TipoEntrega"
        >
          {formik.values.DescricaoTipoEntrega}
        </div>

        <label>Peso Total </label>
        <div
          id="EditarFrete_PesoTotal"
        >{globalMU.formatarValorNumerico(formik.values.PesoTotal, 3, false)}</div>

        <label>Ticket</label>
        <div>
          <input
            name="Ticket"
            type="text"
            id="EditarFrete_InputTicket"
            value={(formik.values.Ticket) ?? ""}
            onChange={(e) => { formik.handleChange(e), store.dispatch(gravarTelasAlteradasNaoSalvaAction("telaEntrega_frete"))}}
            disabled={props.somenteLeitura}
          />
        </div>

        <label>Valor</label>
        <div>
          <InputNumerico
            id="EditarFrete_InputValor"
            onValorModificado={(valorModificado) => {
              formik.setFieldValue("ValorFrete", valorModificado)
              formik.setFieldValue("Valor", valorModificado)
              store.dispatch(gravarTelasAlteradasNaoSalvaAction("telaEntrega_frete"))
            }}
            valor={formik.values.Valor}
            disabled={props.somenteLeitura}
          />
        </div>
      </div>
      
      {!props.somenteLeitura &&
          (
            <div>
              <button
                className={estiloEditarFrete.botao}
                id="EditarFrete_BotaoAplicar"
                onClick={() => props.onAplicarFrete(formik.values)}
              >
                Aplicar
              </button>
            </div>
          )}
    </>
  );
};
